import React from 'react';
import PropTypes from "prop-types";
import { useElementId } from '../../admin/react/helpers/use_element_id';

// Tooltip component

export const Tooltip = ({
  text,
  id,
  className = 'tooltip',
  label = 'More Information',
  icon = 'info-circle',
  onClick,
}) => {
  const elementId = useElementId('tooltip');
  const contentId = id || elementId;
  const buttonId = `${contentId}-button`;
  const contentClassName = `${className}--content`;

  return (
    <>
      <button
        type="button"
        className={className}
        id={buttonId}
        onClick={onClick}
        data-tooltip={true}
        aria-describedby={contentId}
      >
        <i className={`fas fa-${icon}`} aria-hidden="true" />
        {label && <span className="sr-only">{label}</span>}
      </button>
      <span className={contentClassName} id={contentId} role="tooltip" aria-hidden="true">
        {text}
      </span>
    </>
  )
}

Tooltip.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
}
